import AWS from 'aws-sdk';

const configureS3Client = () => {
  AWS.config.update({
    region: process.env.REACT_APP_AWS_REGION,
    accessKeyId: process.env.REACT_APP_ACCESSKEYID_AWS,
    secretAccessKey: process.env.REACT_APP_ACCESSKEYSECRET_AWS,
  });
  return new AWS.S3();
};

export const awsListPage = async ({ marker = undefined, maxKeys = 1000 } = {}) => {
  const s3 = configureS3Client();
  const params = {
    Bucket: process.env.REACT_APP_AWS_BUCKET,
    Prefix: process.env.REACT_APP_AWS_PREFIX,
    MaxKeys: maxKeys,
  };
  if (marker) params.Marker = marker;

  const response = await s3.listObjects(params).promise();
  const items = response.Contents || [];
  const nextMarker = response.IsTruncated ? items.slice(-1)[0]?.Key || null : null;
  // eslint-disable-next-line no-console
  console.log('[awsListPage] page items:', items.length, 'nextMarker exists?', !!nextMarker);
  return {
    items,
    nextMarker,
  };
};

export default awsListPage;


